import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const MAX_PERCENT = 100;

function InputPercentage(props) {
  const { name, inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      allowNegative={false}
      getInputRef={inputRef}
      onValueChange={({ floatValue, value }) => {
        let nextValue = value;
        if (value !== '' && floatValue !== undefined) {
          if (floatValue > MAX_PERCENT) {
            nextValue = String(MAX_PERCENT);
          } else if (floatValue < 0) {
            nextValue = '0';
          }
        }

        onChange({
          target: {
            name,
            value: nextValue,
          },
        });
      }}
      thousandSeparator
      isNumericString
      suffix=" %"
    />
  );
}

InputPercentage.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
};

export default InputPercentage;
